import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, centered }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.margin.large,
  extend: [
    {
      condition: centered,
      style: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
      },
    },
  ],
});

const PanelContent = ({ centered, children }) => {
  const { css } = useFela({ centered });

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

PanelContent.propTypes = {
  children: PropTypes.node,
  centered: PropTypes.bool,
};

export default React.memo(PanelContent);
